import React from 'react'

function VisiBaznas() {
  return (
    <div id='visi' className='pt-20 '>
    <h1 className='text-3xl font-bold text-primary pb-3'>VISI BAZNAS</h1>
    <p className='text-center w-full mx-auto bg-primary text-white font-semibold text-xl py-4 px-6 rounded-lg'>“Menjadi Badan Amil Zakat yang Profesional, Amanah, Menebar manfaat, Menabur Rahmat serta Memuzakkikan Mustahiq”.</p>
</div>
  )
}

export default VisiBaznas